import { PaymentPlanLineStatus } from '@nemuru-eng/js-api-client';

export enum OverduePlanLineStatus {
  OVERDUE = 'overdue',
}

export type PaymentPlanLineStatusExtended = PaymentPlanLineStatus | OverduePlanLineStatus;
